import {PolicyFilter} from 'modules/decisionsNext/api/types';

export type GroupedIds = {
  childIds?: string[];
  parentIds?: string[];
  ultimateParentIds?: string[];
};

export const groupedIds: (keyof GroupedIds)[] = ['ultimateParentIds', 'parentIds', 'childIds'];

type TechnicalIds = {all?: string[]; byType?: string[]};

type PolicyFilterPicked =
  | Pick<
      PolicyFilter,
      | 'clientIds'
      | 'counties'
      | 'departmentIds'
      | 'industryGroupIds'
      | 'industryIds'
      | 'industrySubGroupIds'
      | 'childIntermediaryIds'
      | 'issuingPaperIds'
      | 'parentCarrierIds'
      | 'parentIntermediaryIds'
      | 'policyIds'
      | 'productIds'
      | 'productGroupIds'
      | 'productInsuranceSegmentIds'
      | 'productSuperGroupIds'
      | 'states'
      | 'ultimateCarrierIds'
      | 'ultimateIntermediaryIds'
    > &
      TechnicalIds &
      GroupedIds & {
        statuses?: string[];
        codes?: string[];
      };

export function selectedByLevelToFilter<T extends keyof PolicyFilterPicked>(
  selectedByLevel: string[][],
  filterKeysByLevel: T[]
): Record<T, string[] | undefined> {
  return filterKeysByLevel.reduce<Record<T, string[] | undefined>>((acc, key, index) => {
    const selected = selectedByLevel[index];

    acc[key] = selected?.length ? selected : undefined;

    return acc;
  }, {} as Record<T, string[] | undefined>);
}
